import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { toAbsoluteMediaUrl } from 'src/app/utils/media-url.util';

@Component({
    selector: 'app-file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.scss'],
})
export class FileUploadComponent implements OnChanges {
    @Input() labelText!: string;
    @Output() setImgSrc = new EventEmitter<any>();
    filename: string = '';
    private fileReader!: FileReader;
    private uploadedFile: any;
    /** Value from parent — do not use for preview; Angular resets @Input every CD. */
    @Input() imgSrc: any = null;
    /** Local preview (base64 or server URL); not overwritten by parent until imgSrc changes. */
    displaySrc: any = null;
    /** Last in-browser preview from FileReader; kept so post-upload relative paths do not replace a working data URL. */
    private lastClientDataUrl: string | null = null;

    @ViewChild('fileinput') fileInputRef?: ElementRef<HTMLInputElement>;

    constructor() {
        this.fileReader = new FileReader();
        this.fileReader.addEventListener(
            'load',
            () => {
                this.lastClientDataUrl = this.fileReader.result as string;
                this.displaySrc = this.lastClientDataUrl;
                this.setImgSrc.emit({
                    label: this.labelText,
                    img: this.displaySrc,
                    uploadedFile: this.uploadedFile,
                });
            },
            false
        );
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!changes['imgSrc']) {
            return;
        }
        const v = this.imgSrc;
        if (v == null || v === '') {
            this.lastClientDataUrl = null;
            this.displaySrc = v;
            this.filename = '';
            setTimeout(() => {
                const el = this.fileInputRef?.nativeElement;
                if (el) {
                    el.value = '';
                }
            });
            return;
        }
        if (typeof v !== 'string') {
            this.displaySrc = v;
            return;
        }
        if (v.startsWith('data:')) {
            this.displaySrc = v;
            return;
        }
        if (v.startsWith('http://') || v.startsWith('https://') || v.startsWith('//')) {
            this.lastClientDataUrl = null;
            this.displaySrc = v;
            return;
        }
        // Server-relative path: right after upload we still have a data URL from the same pick.
        if (this.lastClientDataUrl) {
            this.displaySrc = this.lastClientDataUrl;
            return;
        }
        this.displaySrc = toAbsoluteMediaUrl(v) ?? v;
    }

    upload(uploadedFile: any) {
        if (!uploadedFile) {
            return;
        }
        this.uploadedFile = uploadedFile;
        this.filename = uploadedFile.name;
        this.fileReader.readAsDataURL(uploadedFile);
    }
}
